import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { StorageService } from 'src/app/core/services/storage.service';
import { ApplicationService } from '../../../../core/services/application.service';
import { HeaderService } from '../../../../core/services/header.service';

@Component({
  selector: 'app-file-editor-for-application',
  templateUrl: './file-editor-for-application.component.html',
  styleUrls: ['./file-editor-for-application.component.scss']
})

export class FileEditorForApplicationComponent implements OnInit {

  fileName: string = "";
  depName: string = this.data.depName;
  toogleDialog: boolean = false;
  toogleFullScreen: boolean = false;
  searchTerm: string;
  totalWordCount: number = 0;
  curvalue: number = 0;
  currentWordIndex: number = 0;
  totalElements: number;
  regexCode: string = 'gi';
  isSensitiveTitle: string = 'case-insensitive';
  isSensitive: boolean = false;
  autoScroll: boolean = false;
  disableScrollDown: boolean = false;
  findExppr;
  openReplace: boolean = false;
  heading: string = "";

  @ViewChild('jobEditor', { static: true }) jobEditorElement: ElementRef;

  editorForm: UntypedFormGroup = new UntypedFormGroup({
    content: new UntypedFormControl("", [Validators.required]),
    fileName: new UntypedFormControl("", [Validators.required])
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      depName: string,
      appName: string,
      appVersion: string,
      type: string,
      fileName: string
    },
    public dialogRef: MatDialogRef<FileEditorForApplicationComponent>,
    private dialog: MatDialog,
    private _storageService: StorageService,
    private applicationService: ApplicationService,
    private _spinner: NgxSpinnerService,
    private myElement: ElementRef,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.getFileContent(this.data.fileName);
    if (this.data.fileName != null) {
      this.heading = "Edit File";
    }
    else {
      this.heading = "Create File";
    }
    this._spinner.hide("fileEditor");
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  updateVar() {
    this.editorForm.controls["content"].setValue(this.jobEditorElement.nativeElement.innerText);
  }

  replaceChar(val: string) {
    if (val) {
      const re = new RegExp(this.searchTerm, this.regexCode);
      this.editorForm.controls["content"].setValue(this.editorForm.controls["content"].value.replace(re, val));
    }
  }

  onSubmit() {
    this.clearSearch();
    this.updateVar();
    let fileType = this.fileName.split(".").slice(1).join("");
    let myBlob = new Blob([this.editorForm.value.content + "\n"], { type: fileType });
    let file = new File([myBlob], `${this.fileName}`, { type: "text/plain", lastModified: this.headerService.getUserNewDate().getTime() });
    this.dialogRef.close(file);
  }

  getJobElementText() {
    let elementVal = this.jobEditorElement.nativeElement.innerText;
    return elementVal;
  }

  toogleDialogMinMax() {
    if (this.toogleFullScreen && !this.toogleDialog) { this.onFullScreen() }
    if (this.toogleDialog == false) {
      this.toogleDialog = true;
      let element = document.querySelector('.file-editor-dialog');
      element.classList.add('minimize2');
    } else {
      this.toogleDialog = false;
      let element = document.querySelector('.file-editor-dialog');
      element.classList.remove('minimize2');
    }
  }

  onFullScreen() {
    if (this.toogleDialog) { this.toogleDialogMinMax() }
    let element = document.querySelector('.file-editor-dialog');
    if (!this.toogleFullScreen) {
      element.classList.add('fullScreen');
    } else {
      element.classList.remove('fullScreen');
    }
    this.toogleFullScreen = !this.toogleFullScreen;
  }

  getFileContent(fileName: string) {
    if (!fileName) return;
    this._spinner.show("fileEditor");
    this.applicationService
      .GetApplicationFileContent(
        this.depName, this.data.appName,
        this.data.appVersion, this.data.type, fileName
      )
      .pipe(tap(d => this._spinner.hide("fileEditor")))
      .subscribe({
        next: (data) => {
          if (!data) return;
          this.editorForm.controls["content"].setValue(data.toString().split("<br />").join("\n"));
          // this.renderer.setProperty(this.jobEditorElement.nativeElement, 'innerHTML', data.toString().split("<br />").join("\n"))
          this.fileName = fileName;
        }
      })
  }

  searchKeyword(value: string) {
    this.searchTerm = value
    if (this.searchTerm == undefined || this.searchTerm.length == 1 && this.searchTerm == '.') {
    } else {
      if (this.searchTerm == '' || this.searchTerm == undefined) {
        this.clearSearch()
      } else {
        this.findExppr = new RegExp(value, this.regexCode)
        this.totalWordCount = (this.jobEditorElement.nativeElement.innerText.match(this.findExppr) || []).length
        this.autoScroll = false;
      }
      if (this.totalWordCount != 0 && this.currentWordIndex == 0) {
        this.currentWordIndex = 1;
      }
      if (this.totalWordCount == 0) {
        this.currentWordIndex = 0;
      }
    }
  }

  makeCaseSensitive() {
    this.isSensitive = !this.isSensitive;
    this.autoScroll = false;
    if (this.isSensitive == true) {
      this.regexCode = 'g'
      this.isSensitiveTitle = 'case-sensitive'
    } else {
      this.regexCode = 'gi'
      this.isSensitiveTitle = 'case-insensitive'
    }
    // this.editorForm.value.content = this.editorForm.value.content + ''
    this.searchKeyword(this.searchTerm)
  }

  clearSearch() {
    const dom: HTMLElement = this.myElement.nativeElement;
    dom.querySelectorAll('.marked').forEach(mark => {
      mark.setAttribute("style", "background-color: ''")
    })
    this.searchTerm = '';
    this.totalWordCount = 0;
    this.curvalue = 0;
    this.currentWordIndex = 0
    this.regexCode = 'gi'
    this.isSensitive = false;
    this.autoScroll = false;
  }

  removeAttrrStyle(dom) {
    dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #fcf8e3")
  }

  findNext() {
    this.autoScroll = false;
    const dom: HTMLElement = this.myElement.nativeElement;
    this.removeAttrrStyle(dom)
    this.curvalue = this.curvalue + 1;
    this.currentWordIndex = this.currentWordIndex + 1
    if (this.curvalue == this.totalWordCount) {
      this.curvalue = 0
      this.currentWordIndex = this.curvalue + 1
    }
    this.totalElements = dom.querySelectorAll('.marked').length
    dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0;")
  }

  findPrevious() {
    this.autoScroll = false;
    const dom: HTMLElement = this.myElement.nativeElement;
    this.removeAttrrStyle(dom)
    this.curvalue = this.curvalue - 1;
    this.currentWordIndex = this.currentWordIndex - 1
    if (this.currentWordIndex == 0) {
      this.curvalue = this.totalWordCount - 1
      this.currentWordIndex = this.totalWordCount;
    }
    this.totalElements = dom.querySelectorAll('.marked').length
    dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0")
  }

  checkFileExist() {
    return true;
  }
}
